var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "glossary-index" },
    [
      _c(
        "button",
        {
          staticClass: "btn-unstyled text-primary text-sm",
          attrs: { type: "button" },
          on: { click: _vm.collapseAll }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.GlossaryIndex.collapseAllTitleCase")
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" | \n\t"),
      _c(
        "button",
        {
          staticClass: "btn-unstyled text-primary text-sm",
          attrs: { type: "button" },
          on: { click: _vm.expandAll }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.$t("MAIN_CONTENT.GlossaryIndex.expandAllTitleCase")) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.letters, function(letter) {
        return [
          _vm.terms[letter].length > 0
            ? _c(
                "div",
                {
                  key: letter,
                  staticClass: "index-item",
                  class: { disabled: !_vm.terms[letter].length },
                  attrs: { role: "listitem" }
                },
                [
                  _vm.terms[letter].length
                    ? _c(
                        "a",
                        {
                          staticClass: "index-toggle",
                          attrs: {
                            "aria-expanded":
                              _vm.expanded.indexOf(letter) !== -1,
                            href: "javascript:void(0)",
                            role: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleItem(letter)
                            }
                          }
                        },
                        [
                          _c("strong", { staticClass: "letter" }, [
                            _vm._v(_vm._s(letter))
                          ]),
                          _vm._v(" "),
                          _vm.expanded.indexOf(letter) !== -1
                            ? _c("i", {
                                staticClass: "icon-caret fas fa-caret-down",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _c("i", {
                                staticClass: "icon-caret fas fa-caret-right",
                                attrs: { "aria-hidden": "true" }
                              })
                        ]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "disabled",
                          attrs: {
                            "aria-disabled": "true",
                            href: "javascript:void(0)"
                          }
                        },
                        [
                          _c("strong", { staticClass: "letter" }, [
                            _vm._v(_vm._s(letter))
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.expanded.indexOf(letter) !== -1
                    ? _c("div", { staticClass: "terms-menu" }, [
                        _vm.terms[letter]
                          ? _c(
                              "ul",
                              _vm._l(_vm.terms[letter], function(
                                term,
                                termIdx
                              ) {
                                return _c(
                                  "li",
                                  { key: letter + "-" + termIdx },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          "aria-controls": "glossary-results",
                                          href: "javascript:void(0)"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.showDefinition(term)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(term.TERM) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }